export default "__VITE_ASSET__4bce477f__"